module.exports = __webpack_public_path__ + "static/media/samana_white_logo.a2048b38.png";